import React, { useEffect } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { Link, useHistory, useLocation } from "react-router-dom";
import useFotos from "./hooks/useFotos";

import useRepuestos from "./hooks/useRepuestos";

export default function Fotos() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { items } = useRepuestos();

  const location = useLocation();
  let history = useHistory();

  const product = location.state
    ? location.state.product
    : items.length > 0
    ? items[0]
    : history.push("/");

  const { renderFotos, show, setShow, imageToShow } = useFotos({ product });

  //console.log(product);

  return (
    <>
      <Row className="m-0 p-0 my-4 justify-content-center text-left">
        {renderFotos()}
      </Row>
      <Row className="m-0 p-0">
        <Col xs={12}>
          <Modal
            show={show}
            onHide={() => setShow(false)}
            className="modal-large"
          >
            <Modal.Header closeButton>
              <Modal.Title id="example-custom-modal-styling-title">
                {product && product.modelo}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <img
                src={imageToShow}
                alt="foto de accesorio"
                style={{ width: "100%" }}
              />
            </Modal.Body>
          </Modal>
        </Col>
      </Row>
      <Row className="m-0 p-0 mb-4">
        <Col xs={12} className="text-center">
          <Link
            to={{
              pathname: "/repuestos",
              state: {
                product: product,
              },
            }}
          >
            <Button
              size="sm"
              variant="outline-light"
              style={{
                border: "1px solid black",
                fontWeight: "bold",
                fontFamily: "Audi Extended",
                borderRadius: "0px",
                color: "black",
              }}
            >
              volver
            </Button>
          </Link>
        </Col>
      </Row>
    </>
  );
}
